export const FALLBACK_CAMPAIGN_TIMEZONE = 'Europe/Zurich';

const FALLBACK_TIMEZONES = [
  'Africa/Cairo',
  'Africa/Johannesburg',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/New_York',
  'America/Sao_Paulo',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Europe/Berlin',
  'Europe/London',
  'Europe/Paris',
  'Europe/Zurich',
  'Pacific/Auckland',
  'UTC',
] as const;

const getSupportedTimeZones = (): string[] => {
  try {
    const supported = Intl.supportedValuesOf('timeZone');
    if (Array.isArray(supported) && supported.length > 0) {
      return [...supported];
    }
  } catch {
    // Intl.supportedValuesOf may be unavailable in older runtimes
  }

  return [...FALLBACK_TIMEZONES];
};

export const CAMPAIGN_TIMEZONES = getSupportedTimeZones();

export const getDefaultCampaignTimezone = (): string => {
  try {
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone?.trim();
    if (browserTimeZone) {
      Intl.DateTimeFormat(undefined, { timeZone: browserTimeZone });
      return browserTimeZone;
    }
  } catch {
    // Browser timezone unavailable or invalid
  }

  return FALLBACK_CAMPAIGN_TIMEZONE;
};

export const formatTimezoneLabel = (timeZone: string, referenceDate = new Date()): string => {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset',
    }).formatToParts(referenceDate);
    const offset = parts.find((part) => part.type === 'timeZoneName')?.value;
    return offset ? `${timeZone} (${offset})` : timeZone;
  } catch {
    return timeZone;
  }
};

export const resolveCampaignTimezone = (value: string | null | undefined): string => {
  const trimmed = value?.trim();
  if (!trimmed) return getDefaultCampaignTimezone();

  try {
    Intl.DateTimeFormat(undefined, { timeZone: trimmed });
    return trimmed;
  } catch {
    return getDefaultCampaignTimezone();
  }
};
